document.addEventListener('DOMContentLoaded', function() {

    //Product Enquire Start
    //Triggers
    if(document.querySelector('.product-enq-pop-section')){
        checkEnquirePopupSessionStorageExpiration();
        getProductDetailsForEnquiryUsingContactForm();
        triggerProductEnquirePopup();
    }

    function autoFillProductHiddenFields(){

        var product_name = sessionStorage.getItem('productNameEnquire'),
        product_url = sessionStorage.getItem('productUrlEnquire'),
        product_img = sessionStorage.getItem('productImgEnquire'),
        showProductMedia = document.querySelector('.show-product-media'),
        productNameField = document.querySelector('._x51750057 input'),
        productUrlField = document.querySelector('._x53806522 input'),
        showProductName = document.querySelector('.show-product-area .show-product-name');

        console.log('product_name ' + product_name);
        console.log('product_url ' + product_url);

        if(product_name != "undefined" && product_name != null &&
            product_url != "undefined" && product_url != null 
            && productNameField && productUrlField){

                console.log('product_name. ' + product_name);
                console.log('product_url. ' + product_url);

            productNameField.value = product_name;
            productUrlField.value = product_url;
            showProductName.textContent = product_name;

            var productImage = document.createElement('img');
            productImage.src = product_img; 
            productImage.alt = "Product image"; 
            productImage.classList.add('show-product-img'); 
            
            showProductMedia.innerHTML = '';
            showProductMedia.appendChild(productImage);

        }
    }

    function getProductDetailsForEnquiryUsingContactForm(){

        var getProductTitle= document.querySelector('.product__info-container .product__title h1'),
        productInCollectionContactPopButton = document.querySelectorAll('.product-item-for-enquire'),
        getCollectionItems = document.querySelectorAll('#product-grid .grid__item'),
        showProductDataArea = document.querySelector('.show-product-area'),
        productMedia = document.querySelector('.product__media-list li:first-child .product-media-container .product__media img');

        var productTitle = "";
        var productLink = "";
        var productImg = "";

        if(getProductTitle){
            productTitle = getProductTitle.textContent.trim();
            productLink = window.location.href;
            productImg = productMedia ? productMedia.src : null;

            console.log('productTitle. ' + productTitle);
            console.log('productLink. ' + productLink);

            setEnquirePopupSessionStorageWithTimestamp('productNameEnquire', productTitle );
            setEnquirePopupSessionStorageWithTimestamp('productUrlEnquire', productLink );
            setEnquirePopupSessionStorageWithTimestamp('productImgEnquire', productImg );

            autoFillProductHiddenFields();

        }

        if(getCollectionItems.length > 0){

            productInCollectionContactPopButton.forEach(function(button) {
                button.addEventListener('click', function() {

                    var getProductItemInfo = this.closest('.card__content');
                    var getProductItemMedia = this.closest('.card').querySelector('.card__media img:first-of-type');


                    if(getProductItemInfo){

                        getProductItemInfo = getProductItemInfo.querySelector('.product-item-details');

                        productTitle = getProductItemInfo.textContent.trim();
                        productLink = getProductItemInfo.href;
                        productImg = getProductItemMedia ? getProductItemMedia.src : null;

                        console.log('productTitle.. ' + productTitle);
                        console.log('productLink.. ' + productLink);
                        console.log('productImg.. ' + productImg);


                        removeEnquirePopupSessionItems();
            
                        setEnquirePopupSessionStorageWithTimestamp('productNameEnquire', productTitle );
                        setEnquirePopupSessionStorageWithTimestamp('productUrlEnquire', productLink );
                        setEnquirePopupSessionStorageWithTimestamp('productImgEnquire', productImg );

                        autoFillProductHiddenFields();
                        showProductEnquirePopup();

                        showProductDataArea.classList.add("active");
                        
                    }
                });
            });
        }
    }

    function removeEnquirePopupSessionItems(){
        sessionStorage.removeItem('productNameEnquire');
        sessionStorage.removeItem('productUrlEnquire');
        sessionStorage.removeItem('productImgEnquire');
        sessionStorage.removeItem('productNameEnquire_timestamp');
        sessionStorage.removeItem('productUrlEnquire_timestamp');
        sessionStorage.removeItem('productImgEnquire_timestamp');
    }

    function setEnquirePopupSessionStorageWithTimestamp(key, value) {
        const timestamp = new Date().getTime(); // Current time in milliseconds
        sessionStorage.setItem(key, value);
        sessionStorage.setItem(`${key}_timestamp`, timestamp);
    }

    function checkEnquirePopupSessionStorageExpiration() {

        const hourInMilliseconds = 5 * 60 * 1000; // 5 minutes
        //const hourInMilliseconds = 10000; // 10 seconds in milliseconds for testing
        const currentTime = new Date().getTime();

        const productNameTimestamp = sessionStorage.getItem('productNameEnquire_timestamp');

        if (productNameTimestamp && (currentTime - productNameTimestamp > hourInMilliseconds)) {
            // 5 minutes has passed, clear session storage
            removeEnquirePopupSessionItems();
            hideProductEnquirePopup();
        }else{
            //Within 5 minutes & product timestamp exist
            if(productNameTimestamp){
                showProductEnquirePopup();
            }
        }
    }

    function showProductEnquirePopup(){

        var productContactPopForm = document.querySelector('.product-enq-pop-section'),
        productBody = document.querySelector('.template-product'),
        collectionBody = document.querySelector('.template-collection');

        if(productContactPopForm){

            productContactPopForm.classList.add('active');
            document.querySelector('html').classList.add('noscroll');

            if(collectionBody){
                collectionBody.classList.add('formpop-active');
            }else if(productBody){
                productBody.classList.add('formpop-active');
            }

            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    }

    function hideProductEnquirePopup(){

        var productContactPopForm = document.querySelector('.product-enq-pop-section'),
        productBody = document.querySelector('.template-product'),
        collectionBody = document.querySelector('.template-collection');

        if(productContactPopForm){

            productContactPopForm.classList.remove('active');
            document.querySelector('html').classList.remove('noscroll');

            if(collectionBody){
                collectionBody.classList.add('formpop-active');
            }else if(productBody){
                productBody.classList.add('formpop-active');
            }

            removeEnquirePopupSessionItems();
        }
    }


    function triggerProductEnquirePopup(){

        var getProductInfo = document.querySelector('product__info-container .product__title h1'),
        currentURL = window.location.href,
        productContactPopButton = document.querySelector('.product__info-container .enquire-now-pop-btn'),
        closeButton = document.querySelector('.x-button'),
        refuseButton = document.querySelector('.form-refused span'),
        showProductDataArea = document.querySelector('.show-product-area');

        if(productContactPopButton){

            productContactPopButton.addEventListener('click', function() {
                showProductEnquirePopup();
                showProductDataArea.classList.add("active");
            });
        }

        if(closeButton){
            closeButton.addEventListener('click', function() {
                hideProductEnquirePopup();
            });
        }

        if(refuseButton){
            refuseButton.addEventListener('click', function() {
                hideProductEnquirePopup();
            });
        }
    }
    //Product Enquire End

});